// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { fetchTranslationData } from "./store/translationSlice";
import store from "./store";
import { getStore } from "./utils/localStorageUtil";

const localStore = getStore();

// Backend personalizado para cargar traducciones desde Redux
const customBackend = {
  type: "backend",
  read: async (lng, namespace, callback) => {
    try {
      const { countryId, env, lang } = i18n.options.backend;
      const response = await store.dispatch(
        fetchTranslationData({ countryId, env, lang })
      );
      const translations = response.payload; // Las traducciones devueltas por Redux

      if (translations) {
        callback(null, translations); // Cargar traducciones en i18next
      } else {
        callback(new Error("No translations found for this language"), false);
      }
    } catch (error) {
      callback(error, false);
    }
  },
};

i18n
  .use(initReactI18next) // Integración con React
  .use(customBackend) // Backend personalizado para cargar desde Redux
  .init({
    fallbackLng: "en", // Idioma por defecto
    debug: false,
    interpolation: {
      escapeValue: false, // No escapa, seguro en React
    },
    react: {
      useSuspense: true, // Carga las traducciones con suspense
    },
    backend: {
      countryId: localStore?.isoCountry || "gl", // Valor por defecto o dinámico
      env: localStore?.env || "prod", // Valor por defecto o dinámico
      lang: localStore?.lang || 'eng'
    },
  });

// Función para actualizar dinámicamente las opciones del backend
export function updateBackendOptions({ newCountryId, newEnv, lang }) {
  i18n.options.backend.countryId = newCountryId || localStore?.isoCountry || 'gl';
  i18n.options.backend.env = newEnv || localStore?.env || 'prod';
  i18n.options.backend.lang = lang || localStore?.lang || 'eng';

  // Recarga los recursos con las nuevas opciones
  //i18n.reloadResources();
}

export default i18n;
